export const yearAndWeekToKey = (year: number, week: number) => `${year}-${week}`

export const getProcessOrCategoryMaxFourGridClass = () =>
  'gap-6 [grid-template-columns:repeat(auto-fill,minmax(max(30rem,calc((100%-4.5rem)/4)),1fr))]'

